function bindForm($form) {
    var parsleyForm = $form.parsley({
        trigger: "change"
    });

    $form.on('focus', 'input, select', function () {
        var $root = $(this).parent();
        if (!$root.hasClass('error-below')) {
            $root.find('.parsley-errors-list').animate({width: 'toggle'});
        }
    });

    $form.on('focusout', 'input, select', function () {
        var $root = $(this).parent();
        if (!$root.hasClass('error-below')) {
            $root.find('.parsley-errors-list').hide(0).animate({width: 'toggle'}, 200);
        }
    });

    parsleyForm.on('form:submit', function() {
        if($form.data('disable-buttons-on-post')) {
            $(this).find('.btn').each(function() {
                $(this).prop('disabled', true);
            });
        }
        changeButtonToLoading($form.find('[data-post-loader="true"]'));
    });
}